<template>
    <div id="qr" v-if="show">
        <div class="qr-title">
            <img src="../../../assets/gy.png">
        </div>
        <div class="qr-code">
            <img src="../../../assets/weixin.jpg">
        </div>
        <div class="qr-close" @click="show=false">
            关闭
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
export default{
    name:'',
    data(){
        return {
            show:true
        }
    }
}
</script>
<style lang="scss">
#qr{
    position: fixed;
    top:120px;
    right:20px;
    width:180px;
    background-color: #e6e6e6;
    z-index:1000;
    .qr-title{
        padding:0 5px;
    }
    .qr-title img{
        margin-top:5px;
        width:100%
    }
    .qr-code{
        text-align: center;
        padding: 5px;
    }
    .qr-close{
        font-size: 12px;
        color: #535353;
        text-align:right;
        cursor: pointer;
        padding:5px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/components/qr-code.vue